import { CloseOutlined, FilterOutlined } from '@ant-design/icons';
import { Col, Grid, Row, Spin, Drawer } from 'antd';
import CameraMovementMap from 'components/movementMap/cameraMovementMap';
import React, { useEffect, useRef, useState } from 'react';

import * as Api from 'api';
import useApi from 'redux/api/api.hook';
import { CameraPinDetailType } from 'helpers/types';
import useAuth from 'redux/auth/auth.hook';
import FilterMovementMap from 'components/movementMap/filterMovementMap';
import moment from 'moment';
import { Stack, Chip } from '@mui/material';
import classes from './style.module.scss';

const { useBreakpoint } = Grid;

const MovementMapPage = () => {
  const { md } = useBreakpoint();
  const { showLeftFilter, setShowLeftFilter } = useApi();
  const { auth: { profile } } = useAuth();
  const [cameras, setCameras] = useState<CameraPinDetailType[]>([]);
  const [totalActivities, setTotalActivities] = useState([]);
  const [windData, setWindData] = useState([]);
  const [loading, setLoading] = useState(false);
  const movementMap = useRef<any>();

  const [filters, setFilters] = useState<any>({
    tag: '',
    category: '',
    dateStart: moment().format('YYYY-MM-DD'),
    dateEnd: moment().format('YYYY-MM-DD'),
  });

  useEffect(() => {
    if (profile) {
      loadData();
    }
  }, [profile]);

  useEffect(() => {
    setLoading(true);

    const param = { ...filters };
    if (filters.category == 'all') {
      param.category = '';
    }

    Api.MAP_MOVEMENT(param).then(((res: any) => {
      const result = JSON.parse(res.text);
      console.log(result);
      setTotalActivities(result);
      setLoading(false);
    })).catch((error: any) => {
      console.log('error ===>', error);
    });

    const windParam = {
      dateStart: filters.dateStart,
      dateEnd: filters.dateEnd,
    };
    Api.MAP_MOVEMENT_WIND_INFO(windParam).then(((res: any) => {
      const result = JSON.parse(res.text);
      console.log(result);
      setWindData(result);
      setLoading(false);
    })).catch((error: any) => {
      console.log('error ===>', error);
    });
  }, [filters]);

  const loadData = () => {
    setLoading(true);
    Api.MAP_CAMERAS_PINS_DETAIL().then(((res: any) => {
      const result = JSON.parse(res.text);
      setCameras(result.cameras.filter((camera) => camera.type == null || camera.type == undefined));
      setLoading(false);
    })).catch((error: any) => {
      console.log('error ===>', error);
    });
  };

  const handleRightFilter = (willShow) => {
    setShowLeftFilter(willShow);
  };

  const handleFilters = (arg) => {
    console.log('handle filters', arg);
    setFilters(arg);
  };

  return (
    <>
      <Row>
        {md && (
          <Col md={8} lg={6} xxl={4}>
            <div className={classes.content}>
              <FilterMovementMap
                handleFilters={(arg) => handleFilters(arg)}
              />
            </div>
          </Col>
        )}
        {!md && (
          <Drawer
            title="Filter"
            width={300}
            onClose={() => handleRightFilter(false)}
            visible={showLeftFilter}
            zIndex={9999}
            handler={
              (
                <div className={classes.drawerHandle}>
                  {
                    showLeftFilter ? <CloseOutlined onClick={() => handleRightFilter(false)} /> : <FilterOutlined onClick={() => handleRightFilter(true)} />
                  }
                </div>
              )
            }
          >
            <FilterMovementMap
              handleFilters={(arg) => handleFilters(arg)}
            />
          </Drawer>
        )}
        <Col md={16} xs={24} lg={18} xxl={20} className={classes.movementMap}>
          <CameraMovementMap cameras={cameras} ref={movementMap} activities={totalActivities} windData={windData} startDate={filters.dateStart} endDate={filters.dateEnd} />
          <div style={{ display: 'flex', marginTop: '4px' }}>
            <span style={{ marginLeft: 'auto' }}>{md && 'Images Per Hour'}  &nbsp;</span>
            <Stack direction="row" spacing={1}>
              <Chip size="small" label="0" style={{ backgroundColor: '#D7D7D7' }} />
              <Chip size="small" label="1-3" style={{ backgroundColor: '#75b4f9' }} />
              <Chip size="small" label="4-6" style={{ backgroundColor: '#84cc46' }} />
              <Chip size="small" label="7-10" style={{ backgroundColor: '#f1e64e' }} />
              <Chip size="small" label="11-20" style={{ backgroundColor: '#f3aa3b' }} />
              <Chip size="small" label="21-49" style={{ backgroundColor: '#ea3323' }} />
              <Chip size="small" label="50+" style={{ backgroundColor: '#ea33e4' }} />
            </Stack>
          </div>
        </Col>
      </Row>
    </>
  );
};

export default MovementMapPage;
